export const PRESETS = {
  card: {
    width: 200,
  },
};
